<template>

   
  <div class="container">

    <div class="title" :key="changed">{{$t(title)}}</div>
    
    <div ref="html-area"  class="html-area" :class="{'make-inline-block': changed}" spellcheck="false"  contenteditable  @paste="onPaste" @input="change"  v-html="computeValToBB"></div>
    <div ref="html-area-paste"  class="html-area-paste" spellcheck="false"></div>
  
  </div>

</template>

<script>

export default {
  name: 'ui-htmlarea',
  props:{
    val: {
        type: String,
    },
    title:{default:""},
    
  },
  data:function(){
    return {
      on:false,
      htmlArea:undefined,
      htmlAreaPaste:undefined,
      changed:false,
    }
  },
  methods:{
    onPaste(){
      
     

      setTimeout(()=>{
        // only way to proper handling prevent paste html code
        var text=this.$refs['html-area'].innerText;

        // remove tabs from html when paste
        text = text.replace(/\t/g, ' ');

        this.$refs['html-area'].innerText=text;
        this.$refs['html-area-paste'].innerText=text;
        this.change();
      },0)

      
     
     
    },
    change(){
      
      this.changed=true;
     
      if(!this.$refs['html-area']){
        return;
      }

      // get html from html-area
      var html=this.$refs['html-area'].innerHTML;
      
      
      // convert typing to preview html
      this.$refs['html-area-paste'].innerHTML=this.convertTyping(html);

      // remove the html tags except <br> and &nbsp;
      var cleanHtml=this.cleanHtml(html);
      
      
      this.$emit('input',cleanHtml);

    },
    cleanHtml(html){

      // clean html for output
      // php
      html = html.replace(/&lt;\?php/g, "");
      html = html.replace(/\?&gt;/g, "");
      html = html.replace(/&lt;style&gt;/g, "");
      html = html.replace(/&lt;\/style&gt;/g, "");
      html = html.replace(/&lt;script&gt;/g, "");
      html = html.replace(/&lt;\/script&gt;/g, "");
      html = html.replace(/&lt;strong&gt;/g, "");
      html = html.replace(/&lt;\/strong&gt;/g, "");
      html = html.replace(/&lt;em&gt;/g, "");
      html = html.replace(/&lt;\/em&gt;/g, "");

      return html;
    },
    convertTyping(text){

      this.mod_count={
        bold:0,
        italic:0,
      }
      this.htmlOut="";

      for(var i=0;i<text.length;i++){
        var current_char=text.charAt(i);
        
       
        this.htmlOut+=current_char;
        
        if(this.setHtmlTag(current_char,"*","strong",this.mod_count.bold)){
          this.mod_count.bold++;
        }
        if(this.setHtmlTag(current_char,"_","em",this.mod_count.italic)){
          this.mod_count.italic++;
        }
      }
      
      // replace link with http or https
      
      this.htmlOut=this.htmlOut.replace(/&lt;script&gt;/g, (link)=>{
        return "<font color='red'>"+link+"</font>";
      });
      this.htmlOut=this.htmlOut.replace(/&lt;\/script&gt;/g, (link)=>{
        return "<font color='red'>"+link+"</font>";
      });

      this.htmlOut=this.htmlOut.replace(/&lt;style&gt;/g, (link)=>{
        return "<font color='red'>"+link+"</font>";
      });
      this.htmlOut=this.htmlOut.replace(/&lt;\/style&gt;/g, (link)=>{
        return "<font color='red'>"+link+"</font>";
      });
      
      this.htmlOut=this.htmlOut.replace(/&lt;\?php/g, (link)=>{
        return "<font color='red'>"+link+"</font>";
      });
      this.htmlOut=this.htmlOut.replace(/\?&gt;/g, (link)=>{
        return "<font color='red'>"+link+"</font>";
      });

      var exp_match;
      // replace link with anchored link
      exp_match = /(\b(https?|):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/ig;
      this.htmlOut=this.htmlOut.replace(exp_match, (link)=>{
        return "<a href='"+link+"'>"+link+"</a>";
      });

      // replace mail with anchored mailto:link
      //exp_match = /[a-zA-Z0-9-_]{1,}@[a-zA-Z0-9-_]{1,}.[a-zA-Z]{1,}/ig
      //this.htmlOut=this.htmlOut.replace(exp_match, (link)=>{
      //  return "<a href='mailto:"+link+"'>"+link+"</a>";
      //});

      

      return this.htmlOut;
    },
   /*
    getCursor(){
      var pos = window.getSelection(); 
      return pos.anchorOffset;
    },
    setCursor(pos) { 

            // Creates range object 
            var setpos = document.createRange(); 
              
            // Creates object for selection 
            var set = window.getSelection(); 
              
            // Set start position of range 
            setpos.setStart(this.htmlArea.childNodes[0], pos); 
              
            // Collapse range within its boundary points 
            // Returns boolean 
            setpos.collapse(true); 
              
            // Remove all ranges set 
            set.removeAllRanges(); 
              
            // Add range with respect to range object. 
            set.addRange(setpos); 
              
            // Set cursor on focus 
            this.htmlArea.focus(); 
           
    },
    */
    setHtmlTag(current_char,triggerChar,htmlTag,counter){
       if(current_char==triggerChar){
          
          var mod_count=counter % 2;
          
          if(!mod_count){
            // start html
            this.htmlOut+="<"+htmlTag+">";
          }else{
            // end html
            // remove *
            this.htmlOut = this.htmlOut.slice(0, -1); 
            this.htmlOut+="</"+htmlTag+">";
            this.htmlOut+=triggerChar;
          }
          return true
        }
        return false;
    },
    scrollArea(e){
      this.htmlAreaPaste.scrollTop=e.target.scrollTop;
    },
    addListeners(){
      
      this.htmlArea.addEventListener("scroll", this.scrollArea)
      
    },
    removeListeners(){
      this.htmlArea.removeEventListener("scroll", this.scrollArea)
      
    },
    //pasteContent(){
    //strip all html from pasted content
     

     // this.$emit('input',this.htmlArea.innerText);
     //console.dir()
    //}

  },
  computed:{
    computeValToBB(){
      // transform html value from server to plain text (bb)

      var htmlToBB=this.val;
      
      
      htmlToBB = htmlToBB.replace(/<b>/g, "*");
      htmlToBB = htmlToBB.replace(/<\/b>/g, "*");

      htmlToBB = htmlToBB.replace(/<strong>/g, "*");
      htmlToBB = htmlToBB.replace(/<\/strong>/g, "*");

      htmlToBB = htmlToBB.replace(/<i>/g, "_");
      htmlToBB = htmlToBB.replace(/<\/i>/g, "_");

      htmlToBB = htmlToBB.replace(/<em>/g, "_");
      htmlToBB = htmlToBB.replace(/<\/em>/g, "_");

      // transform extract text from a href tag
      htmlToBB = htmlToBB.replace(/<a [^>]+>([^<]+)<\/a>/g, function () {
        return arguments[1];
      });
     
     

      return htmlToBB;

    },
    
  },
  mounted(){
    
    this.htmlArea=this.$refs['html-area'];
    this.htmlAreaPaste=this.$refs['html-area-paste'];
    // convert text to editor format
    //this.change(null);
    this.addListeners();
    this.change();
    
  },
  beforeDestroy(){
    this.removeListeners();
  },
  watch:{
    computeValToBB:{
      handler:function(){
       this.$nextTick(()=>{
         this.change();
       })
       
      }
    }
}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

.html-area>strong, .html-area>b{
  font-weight:normal!important;
  -webkit-text-stroke-width: 0.7px;
  -webkit-text-stroke-color: #000000;
}
.html-area-paste>strong, .html-area-paste>b{
  font-weight:normal!important;
  -webkit-text-stroke-width: 0.7px;
  -webkit-text-stroke-color: #000000;
}
</style>

<style scoped>

.container{
  margin-bottom:15px;
  position:relative;
  width:100%;
  height:150px;
  
}


.title{
  padding:0 5px;
  position:absolute;
  font-size:.7em;
  display:inline-block;
  background-color:#FFFFFF;
  top: -8px;
  left: 5px;
  z-index:11;
}

/* invisible field for editing */
.html-area{
  font-weight:normal;
  display:block; /* leave this in assures the use of br's */
  caret-color: #000000;
  position:relative;
  
  z-index:10;
  width:100%;
  height:100%;
  border:1px solid #707070;
  border-radius:4px;
  outline: none;
  font-size:1.0em;
  padding:0 10px;
  padding-top:10px;
  z-index:1;
  -webkit-user-select: text!important;
  user-select: text!important;
  overflow:hidden;
  overflow-y:scroll;
 
}

.make-inline-block{
  display:inline-block!important;
}

.html-area *,.html-area{
  color:rgba(255,0,0,0);
  /*display:inline-block;  leave this in assures the use of br's */ 
  white-space:pre-wrap;
}

/* output text to converted html here */
.html-area-paste{
  font-weight:normal;
  display:inline-block; /* leave this in assures the use of br's */
  position:absolute;
  left:0;
  top:0;
  white-space:pre-wrap;
  width:100%;
  height:100%;
  border:1px solid #707070;
  border-radius:4px;
  outline: none;
  font-size:1.0em;
  padding:0 10px;
  padding-top:10px;
  overflow:hidden;
  font-kerning: 10px;
  
}

</style>